import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';


// Components

import CommonHeaderContainer from '../../containers/ssap/CommonHeaderContainer';
import SsapNavBarContainer from '../../containers/ssap/SsapNavBarContainer';
import PagesContainer from '../../containers/ssap/PagesContainer';
import AgentPromotion from '../individualPortal/AgentPromotion';


const Ssap = props => {

    const {
        adjustedFlow,
        data: {
            currentPage
        },
        environment: {
            isState
        },
        history
    } = props;

    const MainGridClass = classnames({
        'desktop:grid-col-8 desktop:grid-offset-2': isState.MN,
        'desktop:grid-col-9': !isState.MN,
    });



    return(
        <main className="usa-layout-docs usa-section main-section" id="main-content">
            <div className="grid-container grid-widescreen gi-grid-container">
                <div className="grid-row grid-gap mobile-wrapper--inverse">
                    <SsapNavBarContainer { ...{ ...props, isShown: !isState.MN } }/>
                    <div className={`usa-layout-docs__main ${MainGridClass} usa-prose`}>
                        {
                            currentPage !== -1 &&

                            <Fragment>
                                <CommonHeaderContainer />
                                <PagesContainer { ...{ adjustedFlow, history } } />
                            </Fragment>
                        }
                    </div>
                </div>
            </div>
            <AgentPromotion />
        </main>
    );
};

const mapStateToProps = state => ({
    environment: state.common.environment,
    data: state.ssap.data
});


export default connect(mapStateToProps)(Ssap);
